import { render, staticRenderFns } from "./TrainingPlan.vue?vue&type=template&id=f63c6d46&scoped=true"
import script from "./TrainingPlan.vue?vue&type=script&lang=js"
export * from "./TrainingPlan.vue?vue&type=script&lang=js"
import style0 from "./TrainingPlan.vue?vue&type=style&index=0&id=f63c6d46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63c6d46",
  null
  
)

export default component.exports